import React from "react";
import { Button } from 'react-bootstrap';
import KeynoteSpeakers from "../components/keynoteSpeakers";
import GuestSpeakers from "../components/guestSpeakers";
import Section from "./section";


const Speakers = ({ data }) => {

  const {
    field_heading,
    field_subhead,
    field_desc,
    field_speaker_type,
    relationships,
    field_cta,
    anchor,
  } = data

  return (
    <Section name='speakers' id={anchor} heading={field_heading} subhead={field_subhead}>
      {
        !!field_desc &&
        <div className="page__blurb text-left" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>
      }
      {
        (Number(field_speaker_type) === 1) &&
          <KeynoteSpeakers speakers={relationships.field_tiles_ref}></KeynoteSpeakers>
      }
      {
        (Number(field_speaker_type) === 2) &&
        <GuestSpeakers speakers={relationships.field_tiles_ref}></GuestSpeakers>
      }

      {
        ( !!field_cta ) &&
        <div className="section__text-cta text-center">
          <Button variant="primary" className="btn-submit" href={ field_cta.uri }>{ field_cta.title }</Button>
        </div>
      }

    </Section>
  )

}

export default Speakers;
 